/* eslint-disable linebreak-style */
/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "./app-styles.js";

const CorpAppAccountStyles = document.createElement("dom-module");

CorpAppAccountStyles.innerHTML = `<template>
        <style include="app-styles">
                .borderBottom[selected] {
                        width: calc(100% - 16px);
                        position: absolute;
                        top: 50;
                        border-bottom: 4px solid var(--secondary-brand-color);
                }

                .action:hover {
                        background-color: var(--brand-color-200);
                        color: white;
                        border-radius: 10px;
                        font-weight: bold;
                }

                .actionClicked {
                        background-color: var(--brand-color-200);
                        color: white;
                        border-radius: 10px;
                        font-weight: bold;
                }

                .action-dropdown-hidden {
                        display: none;
                }

                .action-dropdown-show {
                        display: flex;
                        flex-direction: column;
                        position: absolute;
                        right: 0;
                        left: auto;
                        z-index: 101;
                }
                .dateRangestyle{
                        --start-date-input: {
                                width: 100px;
                              }
                              --end-date-input: {
                                width: 100px;
                              }
                              --iron-icon-seperator: {
                                padding-right: 15px;
                                padding-left: 15px;
                              }
                              --oe-input-underline: {
                                display: none;
                              }
                        --paper-input-container-color : var(--custom-secondary-color);
                        --secondary-text-color: black !important;
                }
                .text-decoration {
                        text-decoration: underline;
                        color: var(--brand-color-200);
                        font-weight: bold;
                }

                .text-decoration[selected] {
                        text-decoration: none;
                        color: var(--dark-theme-background-color);
                }

                .brand-color-200 {
                        color: var(--brand-color-200);
                        font-weight: bold;
                }

                .loadMoreBtnPaddingTop {
                        padding-top: 10px;
                }

                .accountDetail {
                        cursor: pointer; 
                        position: relative; 
                        align-items: center;
                        box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.1);
                }

                .arrow {
                        color:var(--backdrop-color) ;
                        width:40px
                }

        </style>

</template>`;

CorpAppAccountStyles.register("corp-app-account-styles");
